import { EDIType } from "@enums/ediType.enum";
import { Model } from "@interfaces/model.interface";

export interface Client extends Model {
	accountingNumber: string;
	address1: string;
	address2: string;
	applyVAT: boolean;
	bankDetailsId: number;
	certificateName?: string;
	deliveryBuffer?: number;
	ediImportDaysBeforeForecasts?: number;
	ediPort?: number;
	ediSelfBilling: boolean;
	ediSenderId?: string;
	ediType?: EDIType;
	ediUrl: string;
	name: string;
	paymentTermId: number;
	postcode: string;
	productionRequestForecastDays: number;
	productionRequestOrderDays: number;
	sendASNsViaEDI: boolean;
	showOnEdi: boolean;
	spotOrderColour: string;
	stagingCertificateName?: string;
	stagingEDIPort?: number;
	stagingEDIType?: EDIType;
	stagingEDIUrl?: string;
	stagingEdiSenderId?: string;
	supplierCode: string;
	telephoneNumber: string;
	town: string;
}

export class Client implements Client {
	accountingNumber = "";
	address1 = "";
	address2 = "";
	applyVAT = true;
	bankDetailsId = 1;
	ediSelfBilling = false;
	name = "";
	postcode = "";
	productionRequestForecastDays = 0;
	productionRequestOrderDays = 0;
	sendASNsViaEDI = false;
	spotOrderColour = "#eeeeee";
	supplierCode = "";
	telephoneNumber = "";
	town = "";

	constructor(data?: Partial<Client>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}